/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, {  Component } from 'react';
import {
    string, object, func, oneOfType, shape, elementType, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ImageEditorControlView from './ImageEditorControlView';

const styles = () => ({
    canvas: {
        width: '100%',
        height: '100%',
    },
});

class ImageEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            showEditor: true,
        };
        this.timer = undefined;
        this.longPressedCallback = undefined;
        this.start = 100;
        this.onHold = this.onHold.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
    }

    componentDidMount() {
    // updates image into canvas at the time of render
        const isFirstLoad = true;
        this.renderCanvasImage(isFirstLoad);
    }

    componentDidUpdate() {
    // updates images after manipulation
        const isFirstLoad = false;
        this.renderCanvasImage(isFirstLoad);
    }

    componentWillUnmount() {
        this.onMouseUp();
    }

    onHoldRepeat(val, axis = 'x', isAddition = false) {
        if (axis === 'x') {
            this.setX(val);
        } else {
            this.setY(val);
        }
        let submitVal = val;
        if (isAddition) {
            submitVal = (val + 5);
        } else {
            submitVal = (val - 5);
        }
        this.timer = setTimeout(() => this.onHoldRepeat(submitVal, axis, isAddition), this.start);
    }

    onHold(val, axis = 'x', isAddition = false) {
        this.longPressedCallback = setTimeout(() => {
            this.onHoldRepeat(val, axis, isAddition);
        }, 1000);
    }

    onMouseDown(val, axis = 'x', isAddition = false) {
        this.onHold(val, axis, isAddition);
    }

    onMouseUp() {
        clearTimeout(this.timer);
        clearTimeout(this.longPressedCallback);
        this.start = 100;
    }

    handleShowEditor = (val) => {
    // handles image edit editor
        this.setState({ showEditor: val });
    }

    renderCanvasImage = (isFirstLoad) => {
        const {
            x, y, width, height,
        } = this.state;
        const {
            image64, imagePreviewCanvasRef, imgHeight, imgWidth,
        } = this.props;
        const canvas = imagePreviewCanvasRef.current;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const image = new Image();
        image.src = image64;
        image.onload = () => {
            if (isFirstLoad) {
                this.setState({ height: image.height, width: (image.height * (imgWidth / imgHeight)) });
            }
            ctx.drawImage(
                image,
                x,
                y,
                width,
                height,
                x <= 0 ? (x) * (-1) : 0, // changing negative to positive
                y <= 0 ? (y) * (-1) : 0, // changing negative to positive
                width,
                height,
            );
        };
    };

    setX = (val) => {
        this.setState({ x: val });
    }

    setY = (val) => {
        this.setState({ y: val });
    }

    setWidth = (val) => {
        const { width } = this.state;
        const { imgHeight, imgWidth } = this.props;
        this.setState({ width: width + val });
        this.setState({ height: ((width + val) * (imgHeight / imgWidth)) });
    }

    handleImageDoneOperation  = () => {
        this.handleShowEditor(false);
    };

    render() {
        const {
            x, y, width, showEditor,
        } = this.state;
        const {
            classes, imagePreviewCanvasRef, setImage,
        } = this.props;

        return (
            <>
                <canvas ref={imagePreviewCanvasRef} className={classes.canvas} />
                {showEditor
                    ? (
                        <ImageEditorControlView
                            x={x}
                            y={y}
                            width={width}
                            handleShowEditor={this.handleImageDoneOperation}
                            setImage={setImage}
                            setWidth={this.setWidth}
                            onMouseUp={this.onMouseUp}
                            onMouseDown={this.onHold}
                            setX={this.setX}
                            setY={this.setY}
                        />
                    )
                    : null}
            </>
        );
    }
}
ImageEditor.propTypes = {
    classes: object.isRequired,
    image64: string.isRequired,
    setImage: func.isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    imgWidth: number.isRequired,
    imgHeight: number.isRequired,

};
export default withStyles(styles)(ImageEditor);
